import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import { Logo } from '../../../types';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

export enum ImageLoadingType {
  Eager = "eager",
  Lazy = "lazy"
}
interface Props {
  image: Logo;
  alt?: string;
  className?: string;
  style?: Record<string, any>;
  isImageDecorative?: boolean;
  loading?: ImageLoadingType;
}

const Image = ({
  className,
  image,
  alt,
  style,
  isImageDecorative,
  loading,
  ...rest
}: Props) => {
  const sharpImage = image?.asset?.localImage?.childImageSharp || null;

  if (sharpImage) {
    return (
      <GatsbyImage
        image={sharpImage.gatsbyImageData as IGatsbyImageData}
        alt={isImageDecorative ? '' : (image?.altText ?? (alt ?? ""))}
        className={className}
        style={style}
        loading={loading}
        {...rest}
      />
    );
  }
  if (!sharpImage && image) {
    return (
      <img
        src={image.asset?.localImage?.publicURL ?? image?.asset?.url}
        alt={isImageDecorative ? '' : image?.altText ?? alt}
        role={isImageDecorative ? 'presentation' : 'img'}
        className={className}
        fetchPriority={loading === ImageLoadingType.Eager ? 'high' : 'auto'}
        loading={loading === ImageLoadingType.Eager ? 'eager' : 'lazy'}
        {...rest}
      />
    );
  }
  return null;
};

export default Image;
